import { css, extractFont, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { RangeStyleStates } from './types';

const styles = {
  root: ({ props }) =>
    css({
      ...extractFont((font) => font.supporting.label, 'web'),
      display: 'inline-flex',
      flexDirection: 'column',
      input: {
        height: '18px',
      },
      ...(props.disabled && { cursor: 'not-allowed' }),
      ...(props.contained && { width: '100%' }),
    }),
  sliderWrapper: ({ theme, props }) =>
    css({
      ...(props.focused
        ? { '& > .MuiSlider-root': { color: theme.colors.primary.fuchsia[40] } }
        : { '&:hover > .MuiSlider-root': { color: theme.colors.neutral.variant[70] } }),
      ...(props.sliderPadding && { padding: props.sliderPadding }),
    }),
} satisfies Styles<RangeStyleStates>;

export const useStyles = withStyles(styles);
